import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { KaufpreisProductFormModel } from '../../factories/kaufpreis-product-form.factory';
import { KraftfahrzeugType } from '@base/backend';

@Component({
  selector: 'app-product-data',
  standalone: true,
  imports: [
    ReactiveFormsModule
  ],
  templateUrl: './product-data.component.html',
  styleUrl: './product-data.component.scss'
})
export class ProductDataComponent {

  @Input() formGroup!: FormGroup<KaufpreisProductFormModel>;
  protected readonly KraftfahrzeugType = KraftfahrzeugType;
}
